import React, { ReactNode, useCallback, useState } from 'react';
import TabsButton from '../../../components/common/TabsButton';
import { flyoutTabs } from '../config';
import DuelSettings from '../forms/DuelSettings';

interface IFlyout {
  title: string;
  component: ReactNode;
}

export const useSettings = () => {
  const [activeFlyout, setActiveFlyout] = useState<IFlyout | null>(null);
  const [isActive, setActive] = useState(false);

  const toggleHandler = useCallback(() => {
    setActive((prev) => !prev);
  }, []);

  const setGameSettings = useCallback(() => {
    setActiveFlyout({
      title: 'game settings',
      component: (
        <TabsButton
          tabName="game_settings"
          elements={flyoutTabs({ toggleFlyout: toggleHandler })}
        />
      ),
    });
    setActive(true);
  }, []);

  const setDuelSettings = useCallback(() => {
    setActiveFlyout({
      title: 'game settings',
      component: <DuelSettings toggleFlyout={toggleHandler} />,
    });
    setActive(true);
  }, []);

  return { setGameSettings, setDuelSettings, activeFlyout, isActive, toggleHandler };
};
